document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(".at-title");

  titles.forEach((title) => {
    title.addEventListener("click", function () {
      const thisTitle = this;
      const thisTab = thisTitle.nextElementSibling;

      // Guard: only act if the next sibling is a content panel
      if (!thisTab || !thisTab.classList.contains("at-tab")) return;

      // Close all toggles first
      titles.forEach((t) => {
        t.classList.remove("active");
        const tab = t.nextElementSibling;
        if (tab && tab.classList.contains("at-tab")) {
          tab.style.display = "none";
        }
      });

      // Open this one if it wasn't already open
      const wasOpen = thisTab.style.display === "block";
      if (!wasOpen) {
        thisTitle.classList.add("active");
        thisTab.style.display = "block";
      }
    });
  });
});

titles.forEach((t) => t.classList.remove("active"));
thisTitle.classList.toggle("active");
